// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface CatalogContainerStyles {
    container?: InjectableCss;
    leftColumn?: InjectableCss;
    rightColumn?: InjectableCss;
}

// Used by catalog pages
export const catalogContainerStyles: CatalogContainerStyles = {
    container: {
        css: css`
            width: 100%;
            display: flex;
            flex-wrap: wrap;
        `,
    },

    leftColumn: {
        css: css`
            width: 327px;
            padding-right: 28px;
            &.mobile-only {
                display: none;
            }
            @media (max-width: 1180px) {
                width: 100%;
                padding-right: 0;
                margin-bottom: 50px;
                display: none;

                &.mobile-only {
                    display: block !important;
                }
            }
        `,
    },
    rightColumn: {
        css: css`
            width: calc(100% - 327px);
            @media (max-width: 1180px) {
                width: 100%;
            }
        `,
    },
};
